import SparkMD5 from 'spark-md5'

/**
 * 大文件上传
 * @author l.y
 */
export default class BigUpload {

    /**
     * 构造基础数据
     * @param Setting
     */
    constructor(Setting) {
        this.Setting = Setting
    }

    /**
     * 上传下一个块
     */
    loadNext() {
        let start = this.currentChunk * this.chunkSize
        let end = start + this.chunkSize >= this.file.size ? this.file.size : start + this.chunkSize
        let trunkfile = this.blobSlice.call(this.file, start, end)
        if (this.gowith) {
            this.reader.readAsBinaryString(trunkfile)
            this.fileSet['currentChunk' + (this.currentChunk + 1)] = trunkfile
        }
    }

    /**
     * 上传进度
     * @param p
     */
    drowSpeed(p) {
        if (this.Setting.drowSpeed != null && typeof (this.Setting.drowSpeed) === 'function') {
            this.Setting.drowSpeed(p);
        }
    }

    /**
     * 启动上传
     * @param e
     * @constructor
     */
    runnable(e) {
        this.currentChunk++
        let p = this.currentChunk * 100 / this.chunks // 上传百分比
        //保留两位小数
        this.drowSpeed(parseInt(p));
        let trunkSpark = new SparkMD5()
        trunkSpark.appendBinary(e.target.result)
        let md5 = trunkSpark.end()
        // --------------------------------上传文件到服务器

        let xhr = new XMLHttpRequest() // 第一步 新建异步请求
        // 新建一个FormData对象
        let formData = new FormData() // ++++++++++
        formData.append('file', this.fileSet['currentChunk' + this.currentChunk]) // 将当前块添加到表单数据对象
        formData.append('currentChunk', this.currentChunk) // 当前块的位置
        formData.append('pt_md5', this.pt_md5) // 文件唯一标识
        formData.append('type', 'file') // 文件唯一标识
        formData.append('md5', md5)
        xhr.open('POST', this.Setting.url) // 第二步骤
        // 发送请求
        xhr.send(formData) // 第三步骤
        xhr.onreadystatechange = () => { // 第四步
            if (xhr.readyState === 4 && xhr.status === 200) {
                let message = JSON.parse(xhr.responseText) // 返回结果解析为json
                if (message.code === '0' && message.data !== null) {
                    // 如果文件处理完成计算MD5，如果还有分片继续处理
                    if (this.currentChunk < this.chunks) {
                        this.loadNext()
                    } else {
                        //this.canvas.remove()
                        this.Setting.callback(message.data)
                    }
                } else {
                    this.currentChunk-- // 返回上一个文件
                    this.gowith = false // 暂停上传
                    this.Setting.callback(false)
                }
            }
        }
    }

    /**
     * 取消上传
     * @param cbk
     */
    cancel(cbk) {
        let xhr = new XMLHttpRequest() // 第一步 新建异步请求
        let formData = new FormData() // ++++++++++
        formData.append('pt_md5', this.pt_md5)
        formData.append('type', 'delete')
        xhr.open('POST', this.Setting.url) // 第二步骤
        xhr.onreadystatechange = () => { // 第四步
            if (xhr.readyState === 4 && xhr.status === 200) {
                let message = JSON.parse(xhr.responseText)
                message = JSON.parse(message)
                if (message.code === '0' && message.data === 'success') {
                    cbk(true) // 取消成功
                } else {
                    cbk(false) // 取消失败
                }
            }
        }
    }

    /**
     * 建立文件上传握手关系
     * @param cbk
     * @param e
     * @constructor
     */
    handshake(cbk, e) { // 握手
        let xhr = new XMLHttpRequest() // 第一步 新建异步请求
        let formData = new FormData() // ++++++++++
        let trunkSpark = new SparkMD5()
        trunkSpark.appendBinary(e.target.result)
        let md5 = trunkSpark.end()
        this.pt_md5 = md5
        formData.append('pt_md5', this.pt_md5)
        formData.append('chunks', this.chunks)
        formData.append('size', this.file.size)
        formData.append('type', 'handshake')
        formData.append('md5', md5) // 计算文件完整的md5值
        formData.append('contentType', this.file.type)
        formData.append('fileName', this.file.name)
        xhr.open('POST', this.Setting.url) // 第二步骤
        // 发送请求
        xhr.send(formData) // 第三步骤
        xhr.onreadystatechange = () => { // 第四步
            if (xhr.readyState === 4 && xhr.status === 200) {
                let message = JSON.parse(xhr.responseText)
                if (message.code === '0') {
                    if (message.data === 'success') {
                        cbk(true) // 回调文件提交任务
                    } else if (typeof message.data !== 'number') {
                        //此处可能该文件已上传，不需要重复上传
                        this.Setting.callback(message.data)
                    } else {
                        this.currentChunk = message.data
                        if (this.currentChunk < this.chunks) {
                            this.loadNext()
                        } else {
                            this.currentChunk--
                            this.loadNext()
                        }
                    }
                } else {
                    cbk(false) // 握手失败
                }
            } else {
                cbk(false) //调用接口失败
            }
        }
    }

    /**
     * 暂停\继续上传
     * @param cbk
     */
    isPlay(cbk) {
        if (this.gowith) {
            this.gowith = false
            if (typeof (cbk) === 'function') cbk(false)
        } else {
            this.gowith = true
            this.loadNext() // 继续执行
            if (typeof (cbk) === 'function') cbk(true)
        }
    }

    /**
     * 监听读取状态
     */
    onUpload() {
        this.reader.onload = e => {
            this.runnable(e)
        }
    }

    /**
     * 启动上传
     */
    startUpload() {
        //初始化参数
        this.file = this.Setting.file.files[0]
        if (!this.file) {
            return false;
        }
        //初始化文件上传类型 逗号分割
        let fileType = this.Setting.fileType
        // 获取上传文件类型
        let type = this.file.type
        if( fileType && type){
          if(!Array.isArray(fileType)){
            alert('文件类型为数组!')
            return
          }
          let bool = false;
          fileType.forEach((val) => {
            if(type.indexOf(val) === -1){
              bool = true
            }
          });
          if(bool){
            alert('上传图片失败,支持格式'+fileType)
            return
          }
        }
        this.reader = new FileReader() // 文件读取
        // 文件每块分割2M，计算分割详情
        this.chunkSize = this.Setting.size
        this.pt_md5 = '' // 文件真实md5
        this.chunks = Math.ceil(this.file.size / this.chunkSize) // 分割后的文件总个数
        this.currentChunk = 0 // 当前上传块
        this.gowith = true // 是否继续上传
        this.fileSet = {} // 文件合集map
        this.blobSlice = File.prototype.mozSlice ||
            File.prototype.webkitSlice ||
            File.prototype.slice // 文件分割方法
        let readerFile = new FileReader() // 文件读取
        readerFile.onload = e => {
            this.handshake(flag => {
                if (flag) {
                    this.loadNext()
                } else {
                    //握手失败！
                    this.Setting.callback(false)
                }
            }, e) // 调用握手
        }
        //监听文件读取
        this.onUpload();
        //设置上传得进度
        this.drowSpeed(0);
        readerFile.readAsBinaryString(this.file);
        return true;
    }
}
